var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { find, forEach, get, isNil, padStart } from 'lodash';
// @ts-ignore
import Tridi from 'react-tridi';
import 'react-tridi/dist/index.css';
import screenfull from 'screenfull';
var ExteriorPanoramaViewer = /** @class */ (function (_super) {
    __extends(ExteriorPanoramaViewer, _super);
    function ExteriorPanoramaViewer(props) {
        var _a, _b, _c;
        var _this = _super.call(this, props) || this;
        _this.fullscreenChangeHandler = function () {
            var container = document.getElementById('exterior_container');
            if (isNil(container)) {
                return;
            }
            // @ts-ignore
            if (screenfull.isFullscreen) {
                // console.log('entered fullscreen');
            }
            else {
                container.style.width = _this.state.containerSize.width + "px";
                container.style.height = _this.state.containerSize.height + "px";
                // @ts-ignore
                screenfull.off('change', _this.fullscreenChangeHandler);
            }
        };
        /**
         * Returns if panorama is currently in fullscreen view
         */
        _this.isFullscreen = function () {
            // @ts-ignore
            return screenfull.isFullscreen;
        };
        _this.getCurrentFrame = function () {
            return _this.state.currentFrame;
        };
        _this.tridiRef = React.createRef();
        console.log('=========', props.panoramaIndex);
        // console.trace();
        var panorama = props.project.exteriorPanoramas[props.panoramaIndex];
        _this.state = {
            // spinViewers: [],
            activeSpinViewer: -1,
            autorotating: false,
            start: 0,
            containerSize: {
                width: (_a = _this.props.width) !== null && _a !== void 0 ? _a : 0, height: (_b = _this.props.height) !== null && _b !== void 0 ? _b : 0,
            },
            hotspots: [],
            hotspotsShown: true,
            project: _this.props.project,
            panorama: panorama,
            currentFrame: (_c = _this.props.initialFrame) !== null && _c !== void 0 ? _c : 0,
            isLoading: true,
        };
        return _this;
    }
    ExteriorPanoramaViewer.prototype.componentDidMount = function () {
        var container = document.getElementById('exterior_panorama');
        if (!isNil(container)) {
            var updateHotspotOffsets_1 = this.setupSpinners(container);
            window.addEventListener('resize', function (_e) {
                updateHotspotOffsets_1();
            });
        }
        if (!isNil(this.props.onLoadFinished)) {
            this.props.onLoadFinished(false);
        }
    };
    ExteriorPanoramaViewer.prototype.setupSpinners = function (_container) {
        var _this = this;
        console.log('============setup spinners');
        var updateHotspotOffsets = function () {
            if (_this.state.activeSpinViewer === -1) {
                return;
            }
            _this.forceUpdate();
            // @ts-ignore
            var currentFrame = _this.state.currentFrame;
            var basePhotoName = _this.state.panorama.id + "-" + padStart((_this.state.panorama.photos.length - currentFrame).toString(10), 3, '0') + ".jpg";
            forEach(_this.state.hotspots, function (hotspot) {
                _this.positionHotspot(hotspot, basePhotoName);
            });
        };
        // const activeIndex = this.props.panoramaIndex;
        /*
        const spinners = this.state.project.exteriorPanoramas.map((panorama, index) => {
          console.log("Create spinner for", panorama.id);
          const options: Partial<SpinViewerOptions> = {
            rowCount: panorama.photos.length, autoHeight: true, colCount: 1, scale: 1, width: '100%',
    
            colRow: [0, this.state.currentFrame],
          }
          if (this.props.useSprite) {
            options.imageUrl = `${this.props.projectLocation}/${panorama.spriteImage}`;
          } else {
            options.imageUrls = panorama.photos.map((photo) => {
              return `${this.props.projectLocation}/${photo}`;
            });
          }
          console.log(panorama.id, options.imageUrls, options.colRow);
    
          const spinner = new SpinViewer(container, options);
    
          if (!isNil(this.state.panorama.detailPhotos) && this.state.panorama.detailPhotos.length > 0) {
            const hotspotStyle: CSSProperties = {
              position: 'absolute', top: 0, left: 0, display: 'block', visibility: 'hidden', zIndex: 2,
            }
            const hotspots: Hotspot[] = map(this.state.panorama.detailPhotos, (detailPhoto) => {
              if (isNil(this.props.createHotspotMarker)) {
                const element = (<div id={`panorama_detail_${detailPhoto.name}`}
                                      className={'exterior_panorama_hotspot'}
                                      style={hotspotStyle}
                                      onClick={event => {
                                        this.props.onHotspotSelected && this.props.onHotspotSelected(detailPhoto, event)
                                      }}>
                  <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg"
                       xmlnsXlink="http://www.w3.org/1999/xlink">
                    <title>search</title>
                    <g id="search" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="info">
                        <circle id="Oval" fill-opacity="0.2" fill="#000000" cx="24" cy="24" r="24"></circle>
                        <line x1="25.8166889" y1="28.1192806" x2="37.3532758" y2="36.0506841" id="Line-3" stroke="#FFFFFF"
                              stroke-width="3" stroke-linecap="round"
                              transform="translate(31.584982, 32.084982) rotate(10.491477) translate(-31.584982, -32.084982) "></line>
                        <circle id="Oval" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"
                                cx="19" cy="19" r="10"></circle>
                      </g>
                    </g>
                  </svg>
                </div>);
                return {detailPhoto, element};
              } else {
                return {
                  detailPhoto,
                  element: (<div id={`panorama_detail_${detailPhoto.name}`} className={'exterior_panorama_hotspot'}
                                 style={hotspotStyle}>this.props.createHotspotMarker(detailPhoto)</div>)
                };
              }
            });
            this.setState({hotspots});
            spinner.on('change', ((_change: any) => {
              updateHotspotOffsets();
            }));
          } else {
            this.setState({hotspots: []});
          }
    
          spinner.on('load', () => {
            // console.log("HERE!", this.state.initialDegrees);
            // spinner.spinTo(this.state.initialDegrees, {duration: 0});
            this.setState({isLoading: false});
            if (!isNil(this.props.onLoadFinished)) {
              this.props.onLoadFinished(true);
            }
            console.log('LOAD', index, activeIndex);
            if (activeIndex == index) {
              spinner.connect();
            }
            if (!isNil(this.props.hotspotsInitialyShown)) {
              this.setState({hotspotsShown: this.props.hotspotsInitialyShown});
            }
            updateHotspotOffsets();
          });
    
          spinner.on('switch', ((change: any) => {
            const divider = 365 / this.props.project.exteriorPanoramas.length;
            const index = Math.floor(change.percent / divider);
            if (index != NaN && index != this.state.activeSpinViewer) {
              this.switchPanorama(index, this.getCurrentFrame());
              if (!isNil(this.props.onPanoramaChanged)) {
                this.props.onPanoramaChanged(index);
              }
            }
          }));
    
          return spinner;
        });
         */
        // const activeSpinner = spinners[this.props.panoramaIndex];
        this.setState({ activeSpinViewer: this.props.panoramaIndex, autorotating: false, hotspots: [] });
        if (!isNil(this.props.autorotateOnStart) && this.props.autorotateOnStart) {
            // let speed = this.props.autorotateSpeed ?? 100;
            // setTimeout(() => {
            // this.autorotate(true, speed);
            // }, 100);
        }
        return updateHotspotOffsets;
    };
    ExteriorPanoramaViewer.prototype.componentDidUpdate = function (_prevProps, _prevState, _snapshot) {
        var _a;
        if (_prevProps.panoramaIndex !== this.props.panoramaIndex) {
            // console.log("component did update", _prevProps.panoramaIndex, "->", this.props.panoramaIndex);
            this.switchPanorama(this.props.panoramaIndex, (_a = this.props.initialFrame) !== null && _a !== void 0 ? _a : 0);
        }
    };
    ExteriorPanoramaViewer.prototype.switchPanorama = function (panoramaIndex, currentFrame) {
        // console.log("Switch panorama", panoramaIndex, currentFrame);
        var panorama = this.props.project.exteriorPanoramas[panoramaIndex];
        this.setState({
            panorama: panorama,
            currentFrame: currentFrame,
            activeSpinViewer: panoramaIndex,
        });
        // const container = document.getElementById('exterior_panorama');
        // if (!isNil(container)) {
        //   // container.removeChild(container.childNodes.item(0));
        //
        // }
    };
    /**
     * Move the view of the panorama the specified amount of degress to the left in the specified amount of time
     *
     * @param angles angle in degree by which the panorama should be moved to the left
     * @param duration duration in milliseconds this move should take
     */
    ExteriorPanoramaViewer.prototype.moveLeft = function (_angles, _duration) {
        if (!isNil(this.tridiRef.current)) {
            this.tridiRef.current.prev();
        }
    };
    /**
     * Move the view of the panorama the specified amount of degress to the right in the specified amount of time
     *
     * @param angles angle in degree by which the panorama should be moved to the right
     * @param duration duration in milliseconds this move should take
     */
    ExteriorPanoramaViewer.prototype.moveRight = function (_angles, _duration) {
        if (!isNil(this.tridiRef.current)) {
            this.tridiRef.current.next();
        }
    };
    /**
     * Starts to autorotate the panorama
     *
     * @param angle the angles to rotate
     * @param duration the duration in ms which the rotation throught the angle should take
     */
    ExteriorPanoramaViewer.prototype.startAutorotate = function (_angle, _duration) {
        if (!isNil(this.tridiRef.current)) {
            // this.state.spinViewer.spinBy(angle, {duration});
            this.tridiRef.current.toggleAutoplay(true);
        }
    };
    /**
     * Stops a running autorotation
     */
    ExteriorPanoramaViewer.prototype.stopAutorotate = function () {
        if (!isNil(this.tridiRef.current)) {
            // const angle = this.state.spinViewer.getAngle();
            // this.state.spinViewer.spinTo(angle);
            this.tridiRef.current.toggleAutoplay(false);
        }
    };
    /**
     * Show all hotspots which are defined on this panorama
     */
    ExteriorPanoramaViewer.prototype.showHotspots = function () {
        if (this.state.hotspotsShown) {
            return;
        }
        this.setState({ hotspotsShown: true });
        // this.state.hotspots.forEach(hotspot => {
        //   const element = document.getElementById(`panorama_detail_${hotspot.detailPhoto.name}`);
        //   if (isNil(element)) {
        //     return;
        //   }
        //   element.style.visibility = 'visible';
        // });
    };
    /**
     * Hide all hotspots which are defined on this panorama
     */
    ExteriorPanoramaViewer.prototype.hideHotspots = function () {
        if (!this.state.hotspotsShown) {
            return;
        }
        this.setState({ hotspotsShown: false });
        // this.state.hotspots.forEach(hotspot => {
        //   const element = document.getElementById(`panorama_detail_${hotspot.detailPhoto.name}`);
        //   if (isNil(element)) {
        //     return;
        //   }
        //   element.style.visibility = 'hidden';
        // });
    };
    /**
     * Returns if hotspots are currently shown on this panorama
     */
    ExteriorPanoramaViewer.prototype.getHotspotsShown = function () {
        return this.state.hotspotsShown;
    };
    ExteriorPanoramaViewer.prototype.positionHotspot = function (hotspot, basePhoto) {
        var element = document.getElementById("panorama_detail_" + hotspot.detailPhoto.name);
        if (isNil(element)) {
            return;
        }
        var displayLocation = find(hotspot.detailPhoto.displayLocations, { basePhoto: basePhoto });
        if (isNil(displayLocation)) {
            element.style.visibility = 'hidden';
        }
        else {
            element.style.visibility = this.state.hotspotsShown ? 'visible' : 'hidden';
            element.style.left = displayLocation.x * 100 + "%";
            element.style.top = displayLocation.y * 100 + "%";
        }
    };
    /**
     * Display a fullscreen view of the panorama
     */
    ExteriorPanoramaViewer.prototype.enterFullScreen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var container, sizes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        container = document.getElementById('exterior_container');
                        if (!(!isNil(container) && screenfull.isEnabled)) return [3 /*break*/, 2];
                        sizes = {
                            width: container.getBoundingClientRect().width, height: container.getBoundingClientRect().height,
                        };
                        return [4 /*yield*/, screenfull.request(container)];
                    case 1:
                        _a.sent();
                        container.style.width = (window.innerHeight / sizes.height) * sizes.width + "px";
                        container.style.height = window.innerHeight + "px";
                        container.style.objectFit = 'contain';
                        this.setState({ containerSize: sizes });
                        screenfull.on('change', this.fullscreenChangeHandler);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Exit a fullscreen view of the panorama
     */
    ExteriorPanoramaViewer.prototype.exitFullScreen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        container = document.getElementById('exterior_container');
                        if (!(!isNil(container) && screenfull.isEnabled)) return [3 /*break*/, 2];
                        return [4 /*yield*/, screenfull.exit()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ExteriorPanoramaViewer.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            this.state.isLoading && React.createElement("div", { className: "lds-ring" },
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null)),
            React.createElement("div", { id: 'exterior_container', className: this.props.hasInterior ? 'exterior_container_interior_present' : 'ExteriorPanoramaView', key: 'exterior_container' },
                React.createElement("div", { id: 'exterior_panorama', style: this.state.isLoading ? { display: 'none' } : {}, onMouseMove: function (event) {
                        var percent = (event.clientY / get(event.target, 'height', 1)) * 100;
                        var divider = 100 / _this.props.project.exteriorPanoramas.length;
                        var index = Math.floor(percent / divider);
                        if (index != NaN && index < _this.props.project.exteriorPanoramas.length && index != _this.state.activeSpinViewer) {
                            _this.switchPanorama(index, _this.getCurrentFrame());
                            if (!isNil(_this.props.onPanoramaChanged)) {
                                _this.props.onPanoramaChanged(index);
                            }
                        }
                    } },
                    React.createElement(Tridi, { ref: this.tridiRef, images: this.state.panorama.photos.map(function (value) {
                            return _this.props.projectLocation + "/" + value;
                        }), showControlBar: false, stopAutoplayOnClick: true, touch: true, mousewheel: true, onLoadChange: function (value) {
                            if (_this.state.isLoading) {
                                if (typeof value === "boolean" && value === true) {
                                    _this.setState({ isLoading: !value });
                                    if (!isNil(_this.props.onLoadFinished)) {
                                        _this.props.onLoadFinished(value);
                                    }
                                }
                            }
                        }, onFrameChange: function (frame) {
                            _this.setState({ currentFrame: frame });
                        } })),
                this.props.children)));
    };
    return ExteriorPanoramaViewer;
}(React.Component));
export default ExteriorPanoramaViewer;
